export default function () {
  if (!globalThis || !globalThis.process) return false;
  return globalThis.process.env.VUE_ENV === 'server';
}
